<template>
  <section style="height: 100%">
    <v-tip></v-tip>
    <router-view v-if="$route.name !== 'homeT'"></router-view>
  </section>
</template>

<script>
import Vue from "vue";
import { changeLanguage } from "@/locale/index";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr"; // https://github.com/se-panfilov/mini-toastr
import { setupCalendar } from "v-calendar";
import { setCookie, getCookie } from "@/apis/cookie";
import { fixUrl } from "@/apis/newmethods";
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn",
};
miniToastr.init({ types: toastTypes });
function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, 1000000, cb);
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};
Vue.use(VueNotifications, options);

export default {
  name: "app",
  data() {
    return {
      routeLogin: false,
      lanList: [],
    };
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      console.log("路由发生了改变");
      // 这里可以编写处理路由变化的逻辑
      window.scrollTo(0, 0);
      next();
    });
    // web
    if (fixUrl("admin-source") == 'web') {
      let token = getCookie('token')
      if (token) {
        setCookie("admin-token", token);
      }
    }
    // admin
    if (fixUrl("admin-source") == 'admin') {
      let token = getCookie('admin-token')
      if (token) {
        setCookie("admin-token", token);
      }
    }
    if (fixUrl("admin-source")) {
      setCookie("admin-source", fixUrl("admin-source"));
    }
    // setCookie("admin-broker-id", "");
    const title = document.getElementById("htmlTitle");
    title.innerHTML = this.$t("common.title");
    this.$bus.$on("getIsLogin", () => {
      console.log(1);
    });
    this.$bus.$on("alert", (data) => {
      const newData = JSON.parse(JSON.stringify(data));
      if (newData.type === "success") {
        newData.type = "info";
      }
      this.msg(newData);
    });
    this.$bus.$on("outLogin", () => {
      // 如果当前页面需要登录 则跳转到登录
      if (this.$route.meta && this.$route.meta.mustLogin) {
        // window.location.href = "/login";
        // window.location.href = "/noLogin";
        this.$router.push("/noLogin");
      }
    });
    this.$bus.$on("isNotUser", () => {
      window.location.href = "/error_500";
    });

    this.$store.dispatch("getPublic");
    this.$store.dispatch("getOpenLanguageList");
    this.$store.dispatch("getUser");
  },
  watch: {
    base: {
      immediate: true,
      handler(v) {
        if (v) {
          changeLanguage(v);
        }
      },
    },
    lan(v) {
      if (v) {
        // 切换时间选择语言
        if (v === "zh_CN") {
          setupCalendar({
            locale: "zh",
          });
        } else {
          setupCalendar({
            locale: "en",
          });
        }
      }
    },
    '$route'(to, from) {
      console.log('路由变化了:', from.path, '->', to.path);
      if (to.path !== '/agentDownLevel') {
        sessionStorage.removeItem("breadcrumbList");
      }
    },
    userInfo: {
      immediate: true,
      handler(v) {
        if (v && v.iCoinUrl) {
          this.getWebIcon(v.iCoinUrl)
        } else {
          this.getWebIcon('')
        }
      },
    },
  },
  computed: {
    base() {
      return this.$store.state.baseData.languageConfList;
    },
    lan() {
      return this.$store.state.baseData.language;
    },
    user() {
      return this.$store.state.baseData.menus;
    },
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    public() {
      return this.$store.state.baseData.public;
    },
    // 用户信息
    userInfo() {
      if (this.$store.state.baseData.user) {
        return this.$store.state.baseData.user;
      }
      return {};
    },
  },
  notifications: {
    msg: {},
  },
  methods: {
    // 获取浏览器设置的icon
    getWebIcon(iCoinUrl) {
      const webIcon = document.getElementById('web-icon');
      webIcon.href = iCoinUrl //iconUrl
    },
  },
  mounted() {
    let currentLan = getCookie("lan");
    document.getElementsByTagName("html")[0].classList.add(currentLan);
  },
};
</script>

<style lang="scss">
.NOAUTO {
  width: 0;
  height: 0;
  opacity: 0;
  position: fixed;
  left: -100px;
  top: -100px;
}

.mini-toastr {
  left: 50% !important;
  margin-left: -150px !important;
  display: none !important;
}

// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";

@font-face {
  font-family: Open Sans;
  src: url("./assets/fonts/Open-Sans.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: fallback;
}

@font-face {
  font-family: robotoregular;
  src: url("./assets/fonts/robotoregular.woff2") format("woff2"),
    url("./assets/fonts/robotoregular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
  font-display: fallback;
}

@font-face {
  font-family: HarmonyOS-Medium;
  src: url("./assets/fonts/HarmonyOS_Sans_SC_Medium.ttf");
  font-style: normal !important;
  font-weight: 500 !important;
}

@font-face {
  font-family: HarmonyOS-Regular;
  src: url("./assets/fonts/HarmonyOS_Sans_SC_Regular.ttf");
  font-style: normal !important;
  font-weight: 400 !important;
}

@font-face {
  font-family: HarmonyOS-Bold;
  src: url("./assets/fonts/HarmonyOS_Sans_SC_Bold.ttf");
  font-style: normal !important;
  font-weight: 700 !important;
}

html.en_US body {
  font: HarmonyOS-Regular, PingFang SC, Hiragino Sans GB, Heiti SC,
    Microsoft YaHei, WenQuanYi Micro Hei, serif !important;

  .enNum {
    font-family: "HarmonyOS-Medium";
    font-style: normal;
    font-weight: 500;
    // color: red !important;
  }
}

html.zh_CN body {
  font: HarmonyOS-Regular, PingFang SC, Hiragino Sans GB, Heiti SC,
    Microsoft YaHei, WenQuanYi Micro Hei, monospace, serif !important;

  .enNum {
    font-family: "HarmonyOS-Medium";
    font-style: normal;
    font-weight: 500;
    // color: red !important;
  }
}
</style>
